import {
    TOP_PLAYERS_OPTIONS,
    TOP_PLAYERS_PLAYER,
    TOP_WIN_OPTIONS,
    TOP_WIN_PLAYER,
} from './constants';
import styles from './duelana-tops.module.scss';
import TopItem from './top-item';

const DuelanaTops = (): JSX.Element => {
    return (
        <section className={styles.container}>
            <TopItem
                playerBackground="yellow-gradient"
                options={TOP_WIN_OPTIONS}
                onChange={(value) => {
                    console.log(value);
                }}
                value={TOP_WIN_OPTIONS[0].name}
                title="Top win"
                players={[...new Array(6).fill(TOP_WIN_PLAYER)]}
            />

            <TopItem
                playerBackground="green-gradient"
                options={TOP_PLAYERS_OPTIONS}
                onChange={(value) => {
                    console.log(value);
                }}
                value={TOP_PLAYERS_OPTIONS[0].name}
                title="Top players"
                players={[...new Array(6).fill(TOP_PLAYERS_PLAYER)]}
            />
        </section>
    );
};

export default DuelanaTops;
